import config from "@/app.config"
import coreApiClient from "core-api"
import Pusher from "pusher-js"

const pusher = new Pusher(config.pusherAppKey, {
  cluster: config.pusherAppCluster,
  authorizer: _authorizer
})

pusher.connection.bind("error", function (error) {
  window.console.error("An error occurred trying to connect to Pusher", error)
})

function _authorizer(channel) {
  return {
    authorize: (socketId, callback) => {
      coreApiClient.auth.authorisePusher(socketId, channel)
        .then(response => {
          callback(null, { auth: response.token })
        })
        .catch(error => {
          callback(new Error(`Error calling auth endpoint: ${error}`), { auth: "" })
        })
    }
  }
}

export default pusher